<div
  [hidden]="!selected"
  class="notification-node-menu flow-menu"
  (click)="$event.stopPropagation()"
  #nodeMenuElement
>
  <div class="notifications">
    <div
      class="content-box"
      *ngFor="let notification of notifications; let idx = index"
    >
      <div class="notification">
        <div class="container-row">
          <lhpe-select
            controlName="notificationGroup"
            placeholder="Group"
            [formGroup]="notification.formGroup!"
            [options]="notificationOptions"
            displayValue="label"
            optionValue="id"
            [required]="true"
          >
          </lhpe-select>
        </div>

        <div class="container-row">
          <lhpe-select
            controlName="frequency"
            placeholder="Frequency"
            [formGroup]="notification.formGroup!"
            [options]="signalFilters"
            displayValue="label"
            optionValue="value"
            [required]="true"
          >
          </lhpe-select>
        </div>

        <div class="container-row button-row">
          <button mat-icon-button class="delete-btn">
            <svg-icon
              src="assets/svg/trashcan.svg"
              [svgStyle]="{
                'width.px': '22.5',
                'height.px': '22.298'
              }"
              svgClass="lightGreyIcon"
              (click)="removeNotification(notification)"
            ></svg-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="add-row">
      <button mat-icon-button (click)="addNotification($event)">
        <svg-icon src="assets/svg/plus-green-circle.svg"></svg-icon>
      </button>
    </div>
  </div>
</div>
